<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper page_to_up">
      <masteradmin-sidebar-menu v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" />
      <admin-sidebar-menu v-if="((admin === true) || ($store.state.switch_admin_username))" />
        <div class="content-wrapper">
        <div class="container-wrapper center">
        <div class="modal-custom" v-show="showOverlay">
          <div class="loader-img-center">
            <i class="fa fa-spinner fa-spin"></i> Please wait...
          </div>
        </div>
          <div>
            <h3 class="d-inline heading">Task Lists</h3>
            <button
                v-on:click="isModalVisible = true, verrors.clear()"
                class="btn btn-red btn-md input-height-15 float-right text-align-right"
                ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Task List</button>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>


              <b-collapse id="nav-collapse" is-nav>
          <div class="search-wrapper col-12">
          <div class="row col-12 override-padding">
            <div
              :class="((masterAdmin === true) && (!$store.state.switch_admin_username)) ? 'col-lg-4 col-md-12 col-12' : 'col-lg-7 col-md-12 col-12'"
              >
            <b-form-input
              class="input-text"
              v-model="search_keyword"
              type="text"
              placeholder="Search by Title"
              @keyup.enter="filterTasklistitems()"
              maxlength="255"
            ></b-form-input>
            </div>
            <div class="col-lg-3 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_status"
                :options="(((masterAdmin === true) && (!$store.state.switch_admin_username)) || (selectedComponent == 'Private')) ? status_options : public_status_options"
                @change="filterTasklistitems()"
              >
              </b-form-select>
            </div>
            <div v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" class="col-lg-3 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_affiliate"
                :options="affiliate_options"
                @change="filterTasklistitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterTasklistitems()">
            <span class="search-icon">
              <i class="fa fa-search"></i>
            </span>
            </div>
            <div class="col-lg-1 col-md-2 col-2 scroll_box cursor-pointer">
              <span class="scroll_up_down" @click="scrollToElement('down')">
                <i class="fa fa-angle-down angle_font"></i>
              </span>
            </div>
          </div>
          </div>
          </b-collapse>
        </b-navbar>
      </div>
          <div class="margin-bottom-10"></div>
          <div>
             <b-card no-body>
               <b-tabs card>
                 <b-tab title="Public" @click="selected_component('Public')" v-bind:active="isActive('Public')">
                 <div class="row tasks_heading_row">
                   <div
                     class="bold cursor-pointer "
                     :class="((masterAdmin === true) && (!$store.state.switch_admin_username)) ? 'col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4' : 'col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6'"
                     v-on:click="sortMethod('name')"
                     >
                     Title
                     <i v-if="publicSortField == 'name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                     v-on:click="sortMethod('status')"
                     >
                     Status
                     <i v-if="publicSortField == 'status' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'status' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))"
                     class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                     >
                     Affiliate
                     <i v-if="publicSortField == 'affiliate_name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'affiliate_name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding"
                     v-on:click="sortMethod('createdBy')"
                     >
                     Created By
                     <i v-if="publicSortField == 'createdBy' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'createdBy' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                 </div>

                  <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                   <b-card-text v-if="task_lists.length > 0">
                      <div class="tasklists-row" v-for="(tasklist, index) in task_lists">
                      <div class="row tasklist-item" style="margin: 0;">
                        <div
                          class=""
                          :class="((masterAdmin === true) && (!$store.state.switch_admin_username)) ? 'col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4' : 'col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6'"
                          >
                          {{tasklist.name}}
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{getStatus(tasklist.status)}}</div>
                        <div v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">{{tasklist.affiliate_name}}</div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding">{{tasklist.created_by}}</div>
                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                            <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                            <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                              <li></li>
                              <li></li>
                              <li></li>
                            </ul>
                            <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                              <div class="action-dd-menu" v-if="((tasklist.status=='DRAFT' || tasklist.status=='PUBLISH') && ((masterAdmin === true) && (!$store.state.switch_admin_username)))" @click="goToEdit(tasklist.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                              <div class="action-dd-menu" v-if="(tasklist.status=='DRAFT' && (masterAdmin === true) && (!$store.state.switch_admin_username))" @click="updateTasklistStatus(tasklist.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                              <div class="action-dd-menu"  v-if="((tasklist.status=='DRAFT' || tasklist.status=='DEACTIVATED') && (masterAdmin === true) && (!$store.state.switch_admin_username))" @click="deleteTaskListConfirm(tasklist.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                              <div class="action-dd-menu"  v-if="tasklist.status=='PUBLISH'" @click="cloneTasklist(tasklist.id)"><i class="cursor-pointer fa fa-clone spacer-icon"></i>Clone</div>
                              <div class="action-dd-menu" v-if="(tasklist.status=='PUBLISH' && (masterAdmin === true) && (!$store.state.switch_admin_username))" @click="deactivateTaskListConfirm(tasklist.id, tasklist.name)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                              <div class="action-dd-menu" @click="previewTaskList(tasklist.id)"><i class="cursor-pointer fa fa-eye spacer-icon"></i>Preview</div>
                              <div class="action-dd-menu" v-if="tasklist.status=='DEACTIVATED'"  @click="activateTasklistConfirm(tasklist.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Activate</div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div><hr></div>
                      </div>
                      <div class="row page_to_down">
                        <div class="mx-auto">
                          <div class="overflow-auto m-3">
                            <b-pagination v-if="rows > 25"
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"
                              v-bind:hide-goto-end-buttons=true
                              @input="showTasklistofPaginated()"
                            ></b-pagination>
                          </div>
                        </div>
                        <div class="page_angle_down">
                          <div class="scroll_box cursor-pointer">
                            <span class="scroll_up_down" @click="scrollToElement('up')">
                              <i class="fa fa-angle-up angle_font"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                   </b-card-text>
                   <b-card-text v-else-if="loading == false">
                        No task list matches your search.
                   </b-card-text>
                 </b-tab>
                 <b-tab title="Private" v-if="((!masterAdmin) || ($store.state.switch_admin_username))" @click="selected_component('Private')" v-bind:active="isActive('Private')">
                 <div class="row tasks_heading_row">
                   <div
                     class="bold cursor-pointer col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6"
                     v-on:click="sortPrivateMethod('name')"
                     >
                     Title
                     <i v-if="privateSortField == 'name' && privateSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="privateSortField == 'name' && privateSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                     v-on:click="sortPrivateMethod('status')"
                     >
                     Status
                     <i v-if="privateSortField == 'status' && privateSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="privateSortField == 'status' && privateSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding"
                     v-on:click="sortPrivateMethod('createdBy')"
                     >
                     Created By
                     <i v-if="privateSortField == 'createdBy' && privateSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="privateSortField == 'createdBy' && privateSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                 </div>

                   <div v-show="privateLoading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                    <b-card-text v-if="private_task_lists.length > 0">
                       <div class="tasklists-row" v-for="(tasklist, index) in private_task_lists">
                       <div class="row tasklist-item" style="margin: 0;">
                         <div class="col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6">{{tasklist.name}}</div>
                         <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{getStatus(tasklist.status)}}</div>
                          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding">{{tasklist.created_by}}</div>
                            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                             <div v-bind:id="'dropdown-container-private'+ index" class="dropdown" @click="toggleDropdown('actionPrivateDropdown'+index+'')">
                             <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu-private' + index">
                               <li></li>
                               <li></li>
                               <li></li>
                             </ul>
                             <div v-bind:id="'actionPrivateDropdown' + index" class="dropdown-content-private">
                               <div class="action-dd-menu" v-if="tasklist.status=='DRAFT'" @click="goToEdit(tasklist.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                               <div class="action-dd-menu" v-if="tasklist.status=='DRAFT'" @click="updateTasklistStatus(tasklist.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                               <div class="action-dd-menu"  v-if="tasklist.status=='DRAFT' || tasklist.status=='DEACTIVATED'" @click="deleteTaskListConfirm(tasklist.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                               <div class="action-dd-menu"  v-if="tasklist.status=='PUBLISH'" @click="cloneTasklist(tasklist.id)"><i class="cursor-pointer fa fa-clone spacer-icon"></i>Clone</div>
                               <div class="action-dd-menu" v-if="tasklist.status=='PUBLISH'" @click="deactivateTaskListConfirm(tasklist.id, tasklist.name)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                               <div class="action-dd-menu" @click="previewTaskList(tasklist.id)"><i class="cursor-pointer fa fa-eye spacer-icon"></i>Preview</div>
                             </div>
                             </div>
                         </div>
                       </div>
                       <div><hr></div>
                       </div>
                       
                       <div class="row page_to_down">
                          <div class="mx-auto">
                            <div class="overflow-auto m-3">
                              <b-pagination v-if="privateRows > 25"
                              v-model="privateCurrentPage"
                              :total-rows="privateRows"
                              :per-page="perPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"
                              v-bind:hide-goto-end-buttons=true
                              @input="showPrivateTasklistofPaginated()"
                              ></b-pagination>
                            </div>
                          </div>
                          <div class="page_angle_down">
                            <div class="scroll_box cursor-pointer">
                              <span class="scroll_up_down" @click="scrollToElement('up')">
                                <i class="fa fa-angle-up angle_font"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                    </b-card-text>
                    <b-card-text v-else-if="privateLoading == false">
                         No task list matches your search.
                    </b-card-text>
                 </b-tab>
               </b-tabs>
             </b-card>
         </div>
      </div>


      <CreateTasklistModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Create Tasklist</h3></div>
        <div slot="body">
          <div class="col-11 override-padding">
            <input v-model="tasklist_title"
                  name="tasklist_title"
                  placeholder="Enter Tasklist Title"
                  class="col-lg-11 input-height-25"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('tasklist_title', 'required')" class="margin-bottom-5 validate-warning-msg">Tasklist title is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-11 override-padding" style="display:flex;">
            <div v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" 
              class="search-padd" 
              id="affliate-wrapper" 
              style="height: 30px;width: 74%;">
              <multiselect v-model="affiliate"
                :options="affiliate_options"
                track-by="value"
                label="text"
                placeholder="Select Affiliate"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                v-bind:name="'affiliate[]'"
                v-bind:id="'affiliate'"
                v-validate="'required'">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
              </multiselect>
            </div>
            <button
                v-on:click="createTasklist()"
                class="btn btn-red col-lg-2 col-sm-2 col-3 input-height-25 createBtn"
                ><b>Create</b></button>

          </div>
          <div v-if="verrors.firstByRule('affiliate[]', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CreateTasklistModal>

      <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to delete the task list?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deleteTasklist(id)">Confirm</button>
        </div>
      </DeleteModal>

      <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to deactivate? </div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deactivateTasklist(deactivateId)">Confirm</button>
        </div>
      </DeactivateModal>

    <ActivateModal :isModalVisible="isActivateModalVisible" :id="activateId"  @close="isActivateModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to Activate? </div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="activateTasklist(activateId)">Confirm</button>
      </div>
    </ActivateModal>


      <CheckTasklistValidationModal :isModalVisible="isDeactivateValidateModalVisible" @close="isDeactivateValidateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">The tasklist "{{ tasklistTitle }}" has been assigned to some users, you can't deactivate this tasklist</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CheckTasklistValidationModal>


      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import CreateTasklistModal from '../admin/create-tasklist-modal.vue';
import router from '../../router/index.js';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import ActivateModal from '../shared/delete_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';
import CheckTasklistValidationModal from '../shared/validation_modal_alert.vue';


Vue.use(VeeValidate, { errorBagName: 'vverrors', fieldsBagName: 'vfields'});

export default {
        data() {
          return {
            filterFlag: false,
            rows: 0,
            perPage: 25,
            currentPage: 1,
            privateCurrentPage: 1,
            privateRows: 0,
            search_status: '',
            status_options: [
              { value: '', text: 'Status' },
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
              { value: 'DEACTIVATED', text: 'Deactivated' }
            ],
            public_status_options: [
              { value: '', text: 'Status' },
              { value: 'PUBLISH', text: 'Published' },
            ],
            task_lists: [],
            private_task_lists: [],
            masterAdmin: false,
            admin: false,
            search_keyword: '',
            loading: false,
            privateLoading: false,
            isModalVisible: false,
            tasklist_title: '',
            showOverlay: false,
            id: '',
            deactivateId: '',
            activateId: '',
            isDeleteModalVisible: false,
            isDeactivateModalVisible: false,
            isDeactivateValidateModalVisible: false,
            isActivateModalVisible: false,
            selectedComponent: 'Public',
            publicSortField: '',
            publicSortBy: '',
            privateSortField: '',
            privateSortBy: '',
            affiliate_options: [],
            search_affiliate: '',
            affiliate: [],
            tasklistTitle: '',
          }
        },

        components: {
          UserMenu,
          GoBack,
          CreateTasklistModal,
          DeleteModal,
          DeactivateModal,
          ActivateModal,
          MasteradminSidebarMenu,
          AdminSidebarMenu,
          Multiselect,
          CheckTasklistValidationModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            isActive: function (tabvalue) {
                 return this.selectedComponent === tabvalue
            },
            selected_component: function (tabvalue) {
               this.selectedComponent = tabvalue;
               this.search_status = '';
               let page_url = 'Tasklists';
               let active_tab = tabvalue;
               store.dispatch('active_tab', { page_url, active_tab })
               this.filterTasklistitems();
            },
            createTasklist() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  axios('/tasklist',
                     {
                       method: 'POST',
                       data:
                        {
                          name: this.tasklist_title,
                          affiliate_selected: this.affiliate,
                        },
                     }
                   )
                  .then((resp) => {
                      this.tasklist_title = '';
                      this.$emit('close');
                      store.dispatch('subtasks', '');
                      router.push("/create-sub-tasklists/" + resp.data);
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });
                }
              })
              .catch(() => {

              });
            },
            toggleDropdown (id) {
                document.getElementById(id).classList.toggle("show");
            },
            showTasklistofPaginated() {
               this.fetchTasklistitems();
               this.filterFlag = false;
            },
            showPrivateTasklistofPaginated() {
               this.fetchPrivateTasklistitems();
               this.filterFlag = false;
            },
            filterTasklistitems() {
               this.filterFlag = true;
               this.fetchTasklistitems();
               if((this.masterAdmin == false) || (store.state.switch_admin_username)) {
                this.fetchPrivateTasklistitems();
               }
            },
            fetchTasklistitems() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_keyword) {
                params.name = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.search_affiliate) {
                params.affiliate = this.search_affiliate
              }
              if (this.publicSortField) {
                params.sortfield = this.publicSortField
              }
              if (this.publicSortBy) {
                params.sortby = this.publicSortBy
              }
              axios.get('/tasklists', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.task_lists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
            fetchPrivateTasklistitems() {
              this.privateLoading = true;
              if(this.filterFlag) {
                 this.privateCurrentPage = 1;
              }
              const params = { _page: this.privateCurrentPage }
              if (this.search_keyword) {
                params.name = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.privateSortField) {
                params.sortfield = this.privateSortField
              }
              if (this.privateSortBy) {
                params.sortby = this.privateSortBy
              }
              axios.get('/private_tasklists', {
                 params: params
              })
              .then((resp) => {
                  this.privateLoading = false;
                  this.private_task_lists = resp.data.data;
                  this.privateCurrentPage = resp.data.page;
                  this.privateRows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
            goToEdit(id) {
               let title = 'Edit';
               store.dispatch('tasklist_title', { title })
               store.dispatch('subtasks', '');
               router.push("/create-sub-tasklists/" + id);
            },
            updateTasklistStatus(tasklist_id, status_text) {
              this.showOverlay = true;
              axios('/tasklist/' + tasklist_id,
               {
                 method: 'PATCH',
                 data: { "status": status_text},
               }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchTasklistitems();
                if((this.masterAdmin == false) || (store.state.switch_admin_username)) {
                 this.fetchPrivateTasklistitems();
                }
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
           },
           cloneTasklist(tasklist_id) {
             this.showOverlay = true;
             axios('/clone-tasklist/' + tasklist_id,
              {
                method: 'POST',
              }
             )
             .then((resp) => {
               this.showOverlay = false;
               store.dispatch('subtasks', '');
               router.push("/create-sub-tasklists/" + resp.data);
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });
           },
           activateTasklistConfirm(tasklist_id) {
             this.isActivateModalVisible = true;
             this.activateId = tasklist_id;
           },
           activateTasklist(tasklist_id) {
             this.isActivateModalVisible = false;
             this.showOverlay = true;
             axios('/tasklist/' + tasklist_id,
              {
                method: 'PATCH',
                data: { "status": 'PUBLISH'},
              }
             )
             .then((resp) => {
               this.showOverlay = false;
               this.fetchTasklistitems();
               if((this.masterAdmin == false) || (store.state.switch_admin_username)) {
                this.fetchPrivateTasklistitems();
               }
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });
          },
           deactivateTaskListConfirm(tasklist_id, tasklist_name) {
              axios('/check-tasklist-assign-count/' + tasklist_id,
                 {
                   method: 'GET',
                 }
               )
              .then((resp) => {
                  if (resp.data.isTasklistValidation) {
                   this.isDeactivateModalVisible = true;
                   this.deactivateId = tasklist_id;
                  } else {
                    this.isDeactivateValidateModalVisible = true;
                    this.tasklistTitle = tasklist_name;
                  }
               })
              .catch(error => {

              });

           },
           deactivateTasklist(tasklist_id) {
             this.isDeactivateModalVisible = false;
             this.showOverlay = true;
             axios('/tasklist/' + tasklist_id,
              {
                method: 'PATCH',
                data: { "status": 'DEACTIVATED'},
              }
             )
             .then((resp) => {
               this.showOverlay = false;
               this.fetchTasklistitems();
               if((this.masterAdmin == false) || (store.state.switch_admin_username)) {
                this.fetchPrivateTasklistitems();
               }
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });
          },
          hideActionMenu(e) {
             var matches = document.getElementsByClassName('dropdown-content');
             for (var i=0; i<matches.length; i++) {
               var container = document.getElementById('dropdown-container'+ i);

               if (!container.contains(e.target)) {
                    if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                       document.getElementById('actionDropdown' + i).classList.remove('show');
                    }
               }
             }
           },
           hidePrivateActionMenu(e) {
              var matches = document.getElementsByClassName('dropdown-content-private');
              for (var i=0; i<matches.length; i++) {
                var container = document.getElementById('dropdown-container-private'+ i);

                if (!container.contains(e.target)) {
                     if (document.getElementById('actionPrivateDropdown' + i).classList.contains("show")) {
                        document.getElementById('actionPrivateDropdown' + i).classList.remove('show');
                     }
                }
              }
            },
           getStatus: function(status) {
             var status_val = this.status_options.findIndex(item => item.value === status);
             return this.status_options[status_val].text;
           },
           deleteTaskListConfirm: function(tasklist_id) {
             this.isDeleteModalVisible = true;
             this.id = tasklist_id;
           },
           deleteTasklist: function(tasklist_id) {
             this.isDeleteModalVisible = false;
             this.showOverlay = true;
             axios('/tasklist/' + tasklist_id,
                {
                  method: 'DELETE',
                }
              )
             .then((resp) => {
                 this.showOverlay = false;
                 this.fetchTasklistitems();
                 if((this.masterAdmin == false) || (store.state.switch_admin_username)) {
                  this.fetchPrivateTasklistitems();
                 }
              })
             .catch(error => {

             });
           },
           previewTaskList(tasklist_id) {
              router.push("/tasklist-preview/"+tasklist_id);
           },
           sortMethod: function(field) {
             this.publicSortField = field;
             if(this.publicSortBy == 'ASC') {
               this.publicSortBy = 'DESC';
             }
             else {
               this.publicSortBy = 'ASC';
             }
             this.fetchTasklistitems();
           },
           sortPrivateMethod: function(field) {
             this.privateSortField = field;
             if(this.privateSortBy == 'ASC') {
               this.privateSortBy = 'DESC';
             }
             else {
               this.privateSortBy = 'ASC';
             }
             this.fetchPrivateTasklistitems();
           },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 var affiliate_option = {value: '', text: 'Select Affiliate'};
                 this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },
            scrollToElement(type) {
             const el = this.$el.getElementsByClassName('page_to_'+type)[0];
              if (el) {
                el.scrollIntoView({behavior: 'smooth'});
              }
            }
          },
         mounted() {
            document.addEventListener('click', this.hideActionMenu);
            document.addEventListener('click', this.hidePrivateActionMenu);
         },
         beforeDestroy() {
            document.removeEventListener('click', this.hideActionMenu);
            document.removeEventListener('click', this.hidePrivateActionMenu);
         },
         created() {
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           this.fetchTasklistitems();
           if((this.masterAdmin == false) || (store.state.switch_admin_username)) {
            this.fetchPrivateTasklistitems();
           }
           if((this.masterAdmin === true) && ((!store.state.switch_admin_username) || (store.state.switch_admin_username == ''))) {
            this.fetchAffiliateOptions();
           }
           store.dispatch('tasklist_title', '');
         }
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.createBtn {
  margin: 10px 0 3px 5px;
}
.scroll_box {
  padding: 0;
  display: flex;
  justify-content: end;
}
.scroll_up_down {
  background-color: #efac91;
  padding: 5px;
  text-align: center;
  width: 40px;
}
.angle_font {
  color: #FFF !important;
  font-size: 1.8rem !important;
}
.page_angle_down { margin: 10px 15px; }
</style>
<style>
#affliate-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#affliate-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/view_tasklist.vue